import { CompanionRuleExecution } from '@frontend/types/app-companion';

export const getExecutionResponseText = (execution: CompanionRuleExecution): string => {
  return execution.result?.response || 'No response available';
};

export const getExecutionLogsUrl = (execution: CompanionRuleExecution): string | null => {
  const executionUrl = execution.result?.links?.self;

  if (!executionUrl) return null;

  const executionIdMatch = executionUrl.match(/\/executions\/([^/]+)$/);
  const agentId = execution.result?.agent_id;

  if (executionIdMatch && agentId) {
    const executionId = executionIdMatch[1];
    return `/agents/specialized/${agentId}?tab=execution&executionId=${executionId}`;
  }

  return null;
};

// Formatting utilities
export const formatJsonForMarkdown = (obj: unknown): string => {
  return '```json\n' + JSON.stringify(obj, null, 2) + '\n```';
};
